// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (min-device-width: 280px) and (max-width: 539px) {
    .help-toggle {
        margin-top: 12px;
    }
}
@media only screen and (min-device-width: 540px) and (max-width: 768px) {
    .help-toggle {
        margin-top: 6px;
    }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
    .help-adjust {
        padding-left: 10px;
        width: 100px;
    }
    .help-toggle {
        margin-top: 6px;
    }
    .standards-link {
        padding-left: 10px;
        width: 157px;
    }
}

@media only screen and (min-width: 1025px) and (max-width: 1366px) {
    .help-toggle {
        margin-top: 16px;
    }
}

@media (max-width: 1000px) {
    #standardAccessModal .modal-header {
        display: flex !important;
        flex-direction: column !important;
        gap: 10px;
    }

    #standardAccessModal .modal-header h5 {
        margin-bottom: 0 !important;
    }

    #standardAccessModal .modal-header label {
        margin: 0 !important;
    }

    #standardAccessModal .modal-header a {
        margin: 0 !important;
    }

    #standardAccessModal .modal-header button {
        margin-left: auto !important;
        position: absolute;
        right: 20px;
    }
}

.custom-file-label {
    width: 75%;
}
.custom-file-input {
    width: 75%;
}
.a-btn {
    display: inline-block;
    position: relative;
    max-width: 100%;
    margin: 0;
    padding: 0.5rem 1.25rem;
    transition: all 0.15s ease-in-out;
    border: 1px solid;
    border-radius: 4px;
    border-color: #e1e3e4;
    /* [1] */
    color: #fff;
    /* [1] */
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 2.2;
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    overflow: hidden;
    vertical-align: middle;
    -webkit-appearance: none;
    appearance: none;
    -webkit-user-select: none;
    user-select: none;
}

@media (pointer: none), (pointer: coarse) {
    .custom-file-label {
        width: 67%;
    }
    .custom-file-input {
        width: 67%;
    }
}

.video-tutorial {
    color: #2c77e8 !important;
    display: table-cell !important;
    vertical-align: middle !important;
    font-size: 0.9rem !important;
}

.video-tutorial:hover {
    color: #2c77e8 !important;
}

@media (max-width: 1024px) {
    .vid-tut {
        display: none;
    }
}
@media (max-width: 1439px) {
    .prod-tour {
        display: none;
    }
}

.loader {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 24px;
    text-align: center;
    /* You can also use spinner animations here */
}

.loader:not(:required):after {
    content: '';
    display: block;
    font-size: 10px;
    width: 1em;
    height: 1em;
    margin-top: -0.5em;
    animation: spinner 1500ms infinite linear;
    border-radius: 0.5em;
    box-shadow: rgba(0, 0, 0, 0.75) 1.5em 0 0 0, rgba(0, 0, 0, 0.75) 1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) 0 1.5em 0 0, rgba(0, 0, 0, 0.75) -1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) -1.5em 0 0 0, rgba(0, 0, 0, 0.75) -1.1em -1.1em 0 0, rgba(0, 0, 0, 0.75) 0 -1.5em 0 0, rgba(0, 0, 0, 0.75) 1.1em -1.1em 0 0;
  }
  @keyframes spinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

@media (min-width: 1025px) {
    .calc-popover, .proj-popover {
        position: fixed;
        z-index: 1050;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/layout/header.component.css"],"names":[],"mappings":"AAAA;IACI;QACI,gBAAgB;IACpB;AACJ;AACA;IACI;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,kBAAkB;QAClB,YAAY;IAChB;IACA;QACI,eAAe;IACnB;IACA;QACI,kBAAkB;QAClB,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,wBAAwB;QACxB,iCAAiC;QACjC,SAAS;IACb;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,4BAA4B;QAC5B,kBAAkB;QAClB,WAAW;IACf;AACJ;;AAEA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,SAAS;IACT,uBAAuB;IAEvB,iCAAiC;IACjC,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,QAAQ;IACR,WAAW;IACX,QAAQ;IACR,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,wBAAwB;IAExB,gBAAgB;IAChB,yBAAyB;IAGzB,iBAAiB;AACrB;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,iCAAiC;IACjC,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;AACA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,eAAe;IACf,kBAAkB;IAClB,6CAA6C;AACjD;;AAEA;IACI,WAAW;IACX,cAAc;IACd,eAAe;IACf,UAAU;IACV,WAAW;IACX,kBAAkB;IAKlB,yCAAyC;IACzC,oBAAoB;IAEpB,wSAAwS;EAC1S;EAmDA;IACE;MAKE,uBAAuB;IACzB;IACA;MAKE,yBAAyB;IAC3B;EACF;;AAEF;IACI;QACI,eAAe;QACf,aAAa;IACjB;AACJ","sourcesContent":["@media only screen and (min-device-width: 280px) and (max-width: 539px) {\n    .help-toggle {\n        margin-top: 12px;\n    }\n}\n@media only screen and (min-device-width: 540px) and (max-width: 768px) {\n    .help-toggle {\n        margin-top: 6px;\n    }\n}\n@media only screen and (min-width: 768px) and (max-width: 1024px) {\n    .help-adjust {\n        padding-left: 10px;\n        width: 100px;\n    }\n    .help-toggle {\n        margin-top: 6px;\n    }\n    .standards-link {\n        padding-left: 10px;\n        width: 157px;\n    }\n}\n\n@media only screen and (min-width: 1025px) and (max-width: 1366px) {\n    .help-toggle {\n        margin-top: 16px;\n    }\n}\n\n@media (max-width: 1000px) {\n    #standardAccessModal .modal-header {\n        display: flex !important;\n        flex-direction: column !important;\n        gap: 10px;\n    }\n\n    #standardAccessModal .modal-header h5 {\n        margin-bottom: 0 !important;\n    }\n\n    #standardAccessModal .modal-header label {\n        margin: 0 !important;\n    }\n\n    #standardAccessModal .modal-header a {\n        margin: 0 !important;\n    }\n\n    #standardAccessModal .modal-header button {\n        margin-left: auto !important;\n        position: absolute;\n        right: 20px;\n    }\n}\n\n.custom-file-label {\n    width: 75%;\n}\n.custom-file-input {\n    width: 75%;\n}\n.a-btn {\n    display: inline-block;\n    position: relative;\n    max-width: 100%;\n    margin: 0;\n    padding: 0.5rem 1.25rem;\n    -webkit-transition: all 0.15s ease-in-out;\n    transition: all 0.15s ease-in-out;\n    border: 1px solid;\n    border-radius: 4px;\n    border-color: #e1e3e4;\n    /* [1] */\n    color: #fff;\n    /* [1] */\n    font-size: 0.875rem;\n    font-weight: 400;\n    line-height: 2.2;\n    text-align: center;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    cursor: pointer;\n    overflow: hidden;\n    vertical-align: middle;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\n@media (pointer: none), (pointer: coarse) {\n    .custom-file-label {\n        width: 67%;\n    }\n    .custom-file-input {\n        width: 67%;\n    }\n}\n\n.video-tutorial {\n    color: #2c77e8 !important;\n    display: table-cell !important;\n    vertical-align: middle !important;\n    font-size: 0.9rem !important;\n}\n\n.video-tutorial:hover {\n    color: #2c77e8 !important;\n}\n\n@media (max-width: 1024px) {\n    .vid-tut {\n        display: none;\n    }\n}\n@media (max-width: 1439px) {\n    .prod-tour {\n        display: none;\n    }\n}\n\n.loader {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    font-size: 24px;\n    text-align: center;\n    /* You can also use spinner animations here */\n}\n\n.loader:not(:required):after {\n    content: '';\n    display: block;\n    font-size: 10px;\n    width: 1em;\n    height: 1em;\n    margin-top: -0.5em;\n    -webkit-animation: spinner 1500ms infinite linear;\n    -moz-animation: spinner 1500ms infinite linear;\n    -ms-animation: spinner 1500ms infinite linear;\n    -o-animation: spinner 1500ms infinite linear;\n    animation: spinner 1500ms infinite linear;\n    border-radius: 0.5em;\n    -webkit-box-shadow: rgba(0, 0, 0, 0.75) 1.5em 0 0 0, rgba(0, 0, 0, 0.75) 1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) 0 1.5em 0 0, rgba(0, 0, 0, 0.75) -1.1em 1.1em 0 0, rgba(0, 0, 0, 0.5) -1.5em 0 0 0, rgba(0, 0, 0, 0.5) -1.1em -1.1em 0 0, rgba(0, 0, 0, 0.75) 0 -1.5em 0 0, rgba(0, 0, 0, 0.75) 1.1em -1.1em 0 0;\n    box-shadow: rgba(0, 0, 0, 0.75) 1.5em 0 0 0, rgba(0, 0, 0, 0.75) 1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) 0 1.5em 0 0, rgba(0, 0, 0, 0.75) -1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) -1.5em 0 0 0, rgba(0, 0, 0, 0.75) -1.1em -1.1em 0 0, rgba(0, 0, 0, 0.75) 0 -1.5em 0 0, rgba(0, 0, 0, 0.75) 1.1em -1.1em 0 0;\n  }\n\n\n@-webkit-keyframes spinner {\n    0% {\n      -webkit-transform: rotate(0deg);\n      -moz-transform: rotate(0deg);\n      -ms-transform: rotate(0deg);\n      -o-transform: rotate(0deg);\n      transform: rotate(0deg);\n    }\n    100% {\n      -webkit-transform: rotate(360deg);\n      -moz-transform: rotate(360deg);\n      -ms-transform: rotate(360deg);\n      -o-transform: rotate(360deg);\n      transform: rotate(360deg);\n    }\n  }\n  @-moz-keyframes spinner {\n    0% {\n      -webkit-transform: rotate(0deg);\n      -moz-transform: rotate(0deg);\n      -ms-transform: rotate(0deg);\n      -o-transform: rotate(0deg);\n      transform: rotate(0deg);\n    }\n    100% {\n      -webkit-transform: rotate(360deg);\n      -moz-transform: rotate(360deg);\n      -ms-transform: rotate(360deg);\n      -o-transform: rotate(360deg);\n      transform: rotate(360deg);\n    }\n  }\n  @-o-keyframes spinner {\n    0% {\n      -webkit-transform: rotate(0deg);\n      -moz-transform: rotate(0deg);\n      -ms-transform: rotate(0deg);\n      -o-transform: rotate(0deg);\n      transform: rotate(0deg);\n    }\n    100% {\n      -webkit-transform: rotate(360deg);\n      -moz-transform: rotate(360deg);\n      -ms-transform: rotate(360deg);\n      -o-transform: rotate(360deg);\n      transform: rotate(360deg);\n    }\n  }\n  @keyframes spinner {\n    0% {\n      -webkit-transform: rotate(0deg);\n      -moz-transform: rotate(0deg);\n      -ms-transform: rotate(0deg);\n      -o-transform: rotate(0deg);\n      transform: rotate(0deg);\n    }\n    100% {\n      -webkit-transform: rotate(360deg);\n      -moz-transform: rotate(360deg);\n      -ms-transform: rotate(360deg);\n      -o-transform: rotate(360deg);\n      transform: rotate(360deg);\n    }\n  }\n\n@media (min-width: 1025px) {\n    .calc-popover, .proj-popover {\n        position: fixed;\n        z-index: 1050;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
